import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { UserRolePermissionsService } from "src/app/shared/services/user-role-permissions/user-role-permissions.service";

@Injectable({
  providedIn: "root",
})
export class DashboardGuard implements CanActivate {
  constructor(
    private router: Router,
    private userRolePermissionsService: UserRolePermissionsService,
  ) {}

  canActivate() {
    if (!this.userRolePermissionsService.canAccessToDashboards()) {
      this.router.navigate(["access-denied"]);
    } else {
      return true;
    }
  }
}
